window.ShippingCache = {

  CEP_TTL:
    7 * 24 * 60 * 60 * 1000,

  SHIPPING_TTL:
    24 * 60 * 60 * 1000,

  get(
    key,
    ttl
  ){

    try{

      const cached =
        localStorage.getItem(
          key
        );

      if(!cached)
        return null;

      const parsed =
        JSON.parse(
          cached
        );

      if(
        Date.now() -
        parsed.timestamp >
        ttl
      ){

        localStorage.removeItem(
          key
        );

        return null;

      }

      return parsed.data;

    }catch{

      return null;

    }

  },

  set(
    key,
    data
  ){

    try{

      localStorage.setItem(
        key,
        JSON.stringify({
          timestamp:
            Date.now(),
          data
        })
      );

    }catch{}

  },

  getCep(zip){

    return this.get(
      `shipping_cep_${zip}`,
      this.CEP_TTL
    );

  },

  saveCep(
    zip,
    data
  ){

    this.set(
      `shipping_cep_${zip}`,
      data
    );

  },

  getShipping(
    zip,
    variantId
  ){

    return this.get(
      `shipping_rates_${zip}_${variantId}`,
      this.SHIPPING_TTL
    );

  },

  saveShipping(
    zip,
    variantId,
    data
  ){

    this.set(
      `shipping_rates_${zip}_${variantId}`,
      data
    );

  }

};